"use client";

import { type ReactNode } from "react";
import { DESKTOP_Z_INDEX } from "./desktopUI.constants";
import { Button, Glyph } from "@/components/desktop/ui";
import { ErrorBoundary } from "@/components/ErrorBoundary";
interface DockErrorBoundaryTranslations {
  unavailable: string;
  retry: string;
}
interface Props {
  children: ReactNode;
  translations: DockErrorBoundaryTranslations;
}
function DockErrorFallback({
  translations,
  onRetry
}: {
  translations: DockErrorBoundaryTranslations;
  onRetry: () => void;
}) {
  return <div className="fixed bottom-4 left-1/2 -translate-x-1/2" style={{
    zIndex: DESKTOP_Z_INDEX.DOCK
  }} data-sentry-component="DockErrorFallback" data-sentry-source-file="DockErrorBoundary.tsx">
            <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-tone-red text-tone-red-ink shadow-hairline">
                <Glyph name="alert" className="h-4 w-4" data-sentry-element="Glyph" data-sentry-source-file="DockErrorBoundary.tsx" />
                <span className="text-sm">{translations.unavailable}</span>
                <Button variant="ghost" size="sm" onClick={onRetry} className="h-7 gap-1 px-2 text-tone-red-ink hover:bg-tone-red-ink/10 hover:text-tone-red-ink" data-sentry-element="Button" data-sentry-source-file="DockErrorBoundary.tsx">
                    <Glyph name="refresh" className="h-3 w-3" data-sentry-element="Glyph" data-sentry-source-file="DockErrorBoundary.tsx" />
                    {translations.retry}
                </Button>
            </div>
        </div>;
}
export function DockErrorBoundary({
  children,
  translations
}: Props) {
  return <ErrorBoundary tags={{
    surface: "dock"
  }} fallback={retry => <DockErrorFallback translations={translations} onRetry={retry} />} data-sentry-element="ErrorBoundary" data-sentry-component="DockErrorBoundary" data-sentry-source-file="DockErrorBoundary.tsx">
            {children}
        </ErrorBoundary>;
}